import {useDismissedHintKeys} from "./HintManager";
import {XCol, XText} from "../../components/xui";
import XGhostButton from "../../components/xui/XGhostButton";
import {api} from "../../lib/api";
import CardFall from "../../components/CardFall";
import {hasPermissionToCreateCard, hasPermissionToManageUser} from "../../lib/permissions";

const adminHintKeys = ["welcome.account"];
const nonAdminHintKeys = ["welcome.account"];

const Hint = ({children}) => (
  <XCol rounded="md" bg="blue600" elevation={2}>
    <CardFall>
      <XCol px={7} pt={5} pb={4} sp={3}>
        {children}
      </XCol>
    </CardFall>
  </XCol>
);

const Message = ({title, children}) => (
  <>
    <XText preset="bold" color="white" size={4}>
      {title}
    </XText>
    <XText color="blue100">{children}</XText>
  </>
);

const hintKeyToComps = {
  "welcome.account": {
    comp: ({root: {loggedInUser, account}, root}) => (
      <Message title={`Welcome to Codecks, ${loggedInUser.name}!`}>
        <XCol sp={1}>
          <p>
            This is the deck library of your project. You can open the decks below to check out the
            cards within.
            {hasPermissionToCreateCard(root) &&
              " Find (or create) some cards relevant to you and move them to your hand!"}
          </p>
        </XCol>
      </Message>
    ),
    condition: ({canManageUsers}) => !canManageUsers,
  },
};

const WelcomeHints = ({root, children}) => {
  const dismissedHintKeys = useDismissedHintKeys();
  if (dismissedHintKeys === "loading") return null;
  const canManageUsers = hasPermissionToManageUser(root);

  const myKeys = canManageUsers ? adminHintKeys : nonAdminHintKeys;

  const firstKey = myKeys.find(
    (key) => !dismissedHintKeys.has(key) && hintKeyToComps[key].condition({root, canManageUsers})
  );
  if (!firstKey) return children;
  const {comp: Comp} = hintKeyToComps[firstKey];
  return (
    <Hint>
      {Comp && <Comp root={root} />}
      <XCol align="start">
        <XGhostButton color="white" onClick={() => api.mutate.hints.dismiss({hintKey: firstKey})}>
          Dismiss
        </XGhostButton>
      </XCol>
    </Hint>
  );
};

export default WelcomeHints;
